/**
 * @generated SignedSource<<eea22097dd8acdd6f054db383c7e1000>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type materialsLibraryQuery$variables = Record<PropertyKey, never>;
export type materialsLibraryQuery$data = {
  readonly libraryMaterials: ReadonlyArray<{
    readonly hasShaders: boolean;
    readonly id: string;
    readonly imageData: string | null;
    readonly imageUrl: string;
    readonly json: string;
    readonly materialFileName: string;
    readonly materialID: any;
    readonly name: string;
    readonly rootUrl: string;
    readonly sellerID: number;
    readonly shaderInputs: ReadonlyArray<{
      readonly inputID: any;
      readonly name: string;
      readonly shaderInputTypeID: number;
    }>;
    readonly shaderOptions: ReadonlyArray<{
      readonly name: string;
      readonly optionID: any;
      readonly shaderOptionTypeID: number;
    }>;
    readonly shaders: {
      readonly fragment: string;
      readonly materialID: any;
      readonly name: string;
      readonly vertex: string;
    } | null;
    readonly sourceTextureImages: ReadonlyArray<{
      readonly fileLength: number;
      readonly materialID: any | null;
      readonly sceneID: any | null;
      readonly sourceID: any | null;
      readonly url: string;
    }>;
    readonly tempMaterialID: any;
    readonly textureImages: ReadonlyArray<{
      readonly imageFileLength: number;
      readonly imageUrl: string;
      readonly textureImageID: any;
    }>;
    readonly url: string;
  }>;
};
export type materialsLibraryQuery = {
  response: materialsLibraryQuery$data;
  variables: materialsLibraryQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "materialID",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "url",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "imageUrl",
  "storageKey": null
},
v4 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "Material",
    "kind": "LinkedField",
    "name": "libraryMaterials",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      },
      (v0/*:: as any*/),
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "tempMaterialID",
        "storageKey": null
      },
      (v1/*:: as any*/),
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "json",
        "storageKey": null
      },
      (v2/*:: as any*/),
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "rootUrl",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "materialFileName",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "sellerID",
        "storageKey": null
      },
      (v3/*:: as any*/),
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "imageData",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "hasShaders",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "MaterialSourceTextureFile",
        "kind": "LinkedField",
        "name": "sourceTextureImages",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "sceneID",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "sourceID",
            "storageKey": null
          },
          (v0/*:: as any*/),
          (v2/*:: as any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "fileLength",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "MaterialTextureImage",
        "kind": "LinkedField",
        "name": "textureImages",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "textureImageID",
            "storageKey": null
          },
          (v3/*:: as any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "imageFileLength",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "MaterialShader",
        "kind": "LinkedField",
        "name": "shaders",
        "plural": false,
        "selections": [
          (v0/*:: as any*/),
          (v1/*:: as any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "vertex",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "fragment",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "MaterialShaderInput",
        "kind": "LinkedField",
        "name": "shaderInputs",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "inputID",
            "storageKey": null
          },
          (v1/*:: as any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "shaderInputTypeID",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "MaterialShaderOption",
        "kind": "LinkedField",
        "name": "shaderOptions",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "optionID",
            "storageKey": null
          },
          (v1/*:: as any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "shaderOptionTypeID",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "materialsLibraryQuery",
    "selections": (v4/*:: as any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "materialsLibraryQuery",
    "selections": (v4/*:: as any*/)
  },
  "params": {
    "cacheID": "65cab19872ae18591c646f464ebc989b",
    "id": null,
    "metadata": {},
    "name": "materialsLibraryQuery",
    "operationKind": "query",
    "text": "query materialsLibraryQuery {\n  libraryMaterials {\n    id\n    materialID\n    tempMaterialID\n    name\n    json\n    url\n    rootUrl\n    materialFileName\n    sellerID\n    imageUrl\n    imageData\n    hasShaders\n    sourceTextureImages {\n      sceneID\n      sourceID\n      materialID\n      url\n      fileLength\n    }\n    textureImages {\n      textureImageID\n      imageUrl\n      imageFileLength\n    }\n    shaders {\n      materialID\n      name\n      vertex\n      fragment\n    }\n    shaderInputs {\n      inputID\n      name\n      shaderInputTypeID\n    }\n    shaderOptions {\n      optionID\n      name\n      shaderOptionTypeID\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "5a5231a9f73189f87f99450fc1f3af49";

export default node;
